import type { TMessages } from '@/types/TMessages'

export const messages = {
  text: 'Даю {agreement} на обработку своих персональных данных в соответствии c {policy}',
  agreement: 'Согласие',
  policy: 'Политикой обработки персональных данных',
  required: 'Обязательное поле',
} satisfies TMessages
